import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { Redirect } from "react-router";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import PageContent from "@my-dld/components/PageContent";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import ServiceDescriptions from "@my-dld/assets/strings/property_serv_desc";
import ServiceContainer, { ServiceCard } from "@my-dld/components/ServiceContainer";
import { navigate } from "@my-dld/utils/StoreUtils";
import { OwnerCommitteeLookup } from "../../ownercommitteeapi/entities";
import { JOPServiceIds, JOPUserType } from "./index";
import { JOPContext } from "@my-dld/contexts/JOPContext";
import { IJOPServices } from "./JOPService";

interface Props extends RoutedViewProps {
	isRequests?: boolean;
}

interface State {
	property?: AssetCard;
	lookups?: OwnerCommitteeLookup[];
	userType?: number;
	jopServices? : IJOPServices;
}

class JOPServicesSelection extends Component<Props, State> {
	static contextType = JOPContext;
	context!: React.ContextType<typeof JOPContext>;
	constructor( props: Props ) {
		super( props );
		const property = props.location.state ? props.location.state.property : undefined;
		const userType = props.location.state ? props.location.state.userType : undefined;
		const jopServices = props.location.state ? props.location.state.jopServices : undefined;
		this.state = { property: property , userType: userType, jopServices: jopServices };
	}

	componentDidMount() {
		const property = this.props.location.state ? this.props.location.state.property : this.context.property;
		if ( property ) {
			this.context.setProperty( property );
		}
		this.setState( { property: property } );
	}

	handleAction = ( id: string ) => {
		const property = this.state.property ?? this.context.property;
		const url = this.props.isRequests ? "/mydld/jop/requests" : "/mydld/jop";
		switch ( id ) {
			case "jop_enquiry":
				navigate( `${ url }/${ JOPServiceIds.ENQUIRY }`, undefined, { property: property , userType : this.state.userType } );
				break;
			case "jop_suggestion":
				navigate( `${ url }/${ JOPServiceIds.SUGGESTION }`, undefined, { property: property , userType : this.state.userType } );
				break;
			case "jop_complaints":
				navigate( `${ url }/${ JOPServiceIds.COMPLAINT }`, undefined, { property: property , userType : this.state.userType } );
				break;
			case "jop_legal":
				navigate( `${ url }/${ JOPServiceIds.LEGAL }`, undefined, { property: property , userType : this.state.userType } );
				break;
		}
	};

	EnquiryService: ServiceCard = {
		id: "jop_enquiry",
		label: Strings.enquiry,
		icon: "enquiries",
		action: this.handleAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: true,
		extraBodyClass: "align-items-center text-center",
	};
	SuggestionService: ServiceCard = {
		id: "jop_suggestion",
		label: Strings.suggestion,
		icon: "suggestion",
		action: this.handleAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: true,
		extraBodyClass: "align-items-center text-center",
	};
	ComplaintsService: ServiceCard = {
		id: "jop_complaints",
		label: Strings.complaints,
		icon: "complaints",
		action: this.handleAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: true,
		extraBodyClass: "align-items-center text-center",
	};
	LegalService: ServiceCard = {
		id: "jop_legal",
		label: Strings.legal,
		icon: "legal",
		action: this.handleAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: true,
		extraBodyClass: "align-items-center text-center",
	};

	render() {
		let services: ServiceCard[] = [];
		if (this.props.isRequests){
			services = [this.EnquiryService, this.SuggestionService, this.ComplaintsService, this.LegalService];
		}
		if(this.state.jopServices?.canInquiry) services.push(this.EnquiryService);
		if(this.state.jopServices?.canSuggestion) services.push(this.SuggestionService);
		if(this.state.jopServices?.canComplaint) services.push(this.ComplaintsService);
		if(this.state.jopServices?.canLegal && this.state.userType === JOPUserType.OWNER ) services.push(this.LegalService);

		const property = this.state.property ?? this.context.property;
		if ( property == null && !this.props.isRequests )
			return <Redirect to={ "/mydld" }/>;
		let val: string, lbl: string;
		let title: string;
		if ( property ) {
			const extract = extractPropInfo( property );
			val = extract.val;
			lbl = extract.lbl;
			title = `${ Strings.jop_services } - ${ lbl } : ${ val }`;
		} else {
			title = Strings.jop_services;
		}
		return <PageContent
			title={ title }
			hideQLinks={ true }>
			<PageTitle title={ Strings.jop_services } paths={ [ DashboardBCItem ] }/>
			<ServiceContainer services={ services } hideTitle={ true } hideQLinks={ true } extraContainerClass={ "p-0" }/>
		</PageContent>;
	}
}

export default JOPServicesSelection;
